export default {
  views: {
    product: {
      plans: {
        title: '選擇套餐'
      },
      cancelPolicy: {
        title: '取消政策'
      },
      recommendations: {
        title: '其他推荐'
      },
      panels: {
        selectDate: '選擇日期',
        selectPlan: '選擇套餐',
        selectPeople: '選擇人數',
        options: '附加商品',
        profile: '個人資料'
      },
      auth: {
        loginOrRegister: '登入 / 註冊'
      }
    },
    book: {
      title: '訂單確認',
      bookingNotice: '請在預訂前確認',
      paymentConfirmation: '請在支付前確認',
      tip: '為確認訂單，請在15分鐘內完成操作',
      sessionInfo: '預訂信息'
    },
    bookConfirm: {
      productInfo: '商品資訊',
      sessionConfirmed: '已確認',
      sessionUnconfirmed: '未確認',
      paymentInfo: '付款資訊',
      paymentConfirmation: {
        warningTitle: '請確認取消政策：',
        warningText: '該商品一旦購買將無法退款。',
        agreementText: '我已確認並同意'
      },
      prePaymentConfirmation: {
        title: '付款前確認事項',
        checkInput: '請確認輸入內容是否正確。',
        emailNotice:
          '注意：如果您設置了域名郵件過濾，請在預約前將「@linktivity.co.jp」添加到白名單。',
        agreementText: '我已確認並同意上述事項。'
      },
      paymentAmount: {
        total: '支付金額（含税）',
        details: '詳細',
        note: '日圓以外的幣種金額為依據當前匯率計算的預估金額，與實際扣款金額可能略有差異，僅供參考。'
      },
      confirmPaymentDialogTitle: '付款確認',
      participantInfo: {
        title: '參與者資訊',
        dialogTitle: '修改參與者資訊',
        change: '變更',
        password: '密碼',
        validation: {
          passwordRequired: '請輸入密碼'
        }
      },
      couponApplied: '優惠券已成功使用',
      couponFailed: '優惠券使用失敗',
      couponRemoved: '優惠券已成功移除',
      couponRemoveFailed: '優惠券移除失敗',
      actionButtons: {
        back: '返回',
        toPayment: '去付款'
      }
    },
    voucher: {
      pdf: '打印用PDF',
      html: '憑證'
    },
    bookingDetail: {
      title: '預訂詳情',
      detailInfo: '預訂詳情',
      startDate: '參加日期',
      validityPeriod: '有效期',
      voucherInfo: '憑證',
      digitalTicket: '電子票',
      invoice: '收據/發票',
      invoiceSend: '開立',
      invoiceSent: '發票已開立',
      redemption: '使用電子票',
      meetingPoint: '入場位置指南',
      beforeTrip: '使用前確認事項',
      bookingAction: '預訂操作',
      cancelBooking: '取消預訂',
      cancelConfirmPolicy: '請確認取消政策：',
      customerName: '預訂人',
      actualPayment: '付款金額',
      refundAmount: '退款金額',
      orderId: '預訂ID',
      orderCompletionTime: '預訂時間',
      digitalTicketValidPeriod: 'QR碼僅在使用當天有效',
      digitalTicketWaiting: '*訂單確認後，電子票將在此顯示',
      sending: '發送中...',
      sendToEmail: '發送至郵箱',
      cancelConfirm: '是否確認取消訂單？',
      cancelFee: '取消費用',
      cancelRemarkSelect: '請選擇取消原因',
      inclusion: '包含的物品',
      checklist: '注意事項',
      restrictions: '參加限制',
      requirements: '參加前及參加時須知事項',
      attireItems: '參加時所需服裝及攜帶物品',
      otherInfo: '備考・其他',
      attachmentType: {
        ATTACHMENT_TYPE_PDF: 'PDF',
        ATTACHMENT_TYPE_IMAGE: '圖片'
      }
    },
    cancelReason: {
      CANCEL_REASON_OTHER: '其他',
      CANCEL_REASON_MODIFY_BOOKING: '變更預訂日期或人數',
      CANCEL_REASON_BOOKED_BY_MISTAKE: '誤訂',
      CANCEL_REASON_DUPLICATE_BOOKING: '因重複預訂',
      CANCEL_REASON_HEALTH_CONDITION: '生病',
      CANCEL_REASON_TRANSPORTATION_ISSUE: '航班取消、延誤或變更',
      CANCEL_REASON_SCHEDULE_CONFLICT: '行程有變',
      CANCEL_REASON_CHANGE_TO_OTHER_PRODUCT: '改訂為其他商品'
    },
    common: {
      withDashSeparated: '{{val1}} - {{val2}}'
    },
    home: {
      title: 'Triplabo',
      header: {
        alt: 'Triplabo'
      },
      search: {
        placeholder: '搜尋商品'
      },
      ticketList: {
        title: '票券一覽'
      },
      enjoyPack: {
        title: '暢遊套餐'
      }
    }
  }
};
